export default __webpack_public_path__ + "static/media/DaimlerCAC-Regular.fec2b00c.eot";